import { Container, Grid, Tab, Tabs } from '@material-ui/core';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import ChainCompaniesTable from './companies/ChainCompaniesTable';

const ChainCompaniesPage = () => {
    const { chainId } = useParams();

    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                <Tabs orientation="vertical" variant="scrollable" value={1}>
                    <Tab label="Chain" component={Link} to={`/admin/chains/update/${chainId}/`} />
                    <Tab
                        label="Companies"
                        component={Link}
                        to={`/admin/chains/update/${chainId}/companies/`}
                    />
                    <Tab
                        label="Price items"
                        component={Link}
                        to={`/admin/chains/update/${chainId}/priceitems/`}
                    />
                </Tabs>
                <Grid className="pageContent">
                    <ChainCompaniesTable chainId={chainId} />
                </Grid>
            </Grid>
        </Container>
    );
};

export default ChainCompaniesPage;
